<img class="scale" [src]="scaleImage" />
<div [ngClass]="pointerClass" [style.transform]="pointerTransform">
  <img [src]="pointerImage" />
</div>
